"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Constants = require("../00_environment/Constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LeftPaneWrapper = function LeftPaneWrapper(_ref) {
  var _ref$fullHeight = _ref.fullHeight,
      fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight,
      _ref$noSidePadding = _ref.noSidePadding,
      noSidePadding = _ref$noSidePadding === void 0 ? false : _ref$noSidePadding,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      //  paddingTop: 20,
      //  paddingBottom: 30,
      padding: noSidePadding ? 0 : _Constants.panePadding,
      marginBottom: fullHeight ? 0 : 100,
      minHeight: fullHeight ? '100%' : 'undefined'
    }
  }, children);
};

var _default = LeftPaneWrapper;
exports["default"] = _default;